<template>
  <div class="pending-payment-container generic-list scroll-container">
    <v-row>
      <v-col class="hidden-sm-and-down" cols="0" md="3">
        <MenuNavigator class="menu-navigator" />
      </v-col>
      <v-col cols="12" md="9" class="pa-3">
        <ProfileTitle :category="category" />

        <div class="pa-3">
          <template v-if="pendingPaymentInfos">
            <category-block
              :target="category"
              position="position1"
              class="category-block category-block-1"
              :container="false"
            />
            <span
              v-if="$te('pendingPayment.pendingPaymentText1')"
              class="d-block pending-payment-text1"
            >
              {{ $t("pendingPayment.pendingPaymentText1") }}
            </span>
            <span
              v-if="$te('pendingPayment.pendingPaymentText2')"
              class="d-block pending-payment-text2"
            >
              {{ $t("pendingPayment.pendingPaymentText2") }}
            </span>
            <v-list
              v-for="pendingPayment in pendingPaymentInfos"
              :key="pendingPayment.orderId"
              class="pending-payment-list mt-3 mb-8"
            >
              <v-list-item
                class="pending-payment-list-item d-flex flex-column flex-sm-row"
              >
                <v-list-item-content class="pending-payment-list-item-content">
                  <v-list-item-title
                    class="pending-payment-list-item-title d-flex align-center"
                  >
                    <span
                      class="pending-payment-list-item-order-id font-weight-bold"
                    >
                      {{
                        $t("pendingPayment.orderId", {
                          orderId: pendingPayment.orderId
                        })
                      }}
                    </span>
                    <v-spacer></v-spacer>
                    <span
                      class="pending-payment-list-item-amount primary--text text--lighten-1 font-weight-bold"
                    >
                      {{ $n(pendingPayment.amount, "currency") }}
                    </span>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    class="pending-payment-list-item-subtitle mt-1"
                  >
                    {{ $t("pendingPayment.toBePaid") }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action
                  class="pending-payment-list-item-action justify-end"
                >
                  <v-btn
                    color="primary"
                    large
                    depressed
                    :href="pendingPayment.paymentLink"
                    >{{ $t("pendingPayment.payNowBtn") }}</v-btn
                  >
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </template>
          <template v-else>
            <v-alert type="success">
              {{ $t("pendingPayment.noPendingPayments") }}
            </v-alert>
          </template>

          <span
            v-if="$te('pendingPayment.pendingPaymentText3')"
            class="d-block pending-payment-text3 pt-2 mb-2"
          >
            {{ $t("pendingPayment.pendingPaymentText3") }}
          </span>
          <category-block
            :target="category"
            position="position2"
            class="category-block category-block-2 pt-2"
            :container="false"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import MenuNavigator from "@/components/profile/MenuNavigator";
import ProfileTitle from "@/components/profile/ProfileTitle";

import categoryMixin from "~/mixins/category";

import { mapGetters } from "vuex";
import { getPersonInfo } from "~/service/ebsn";

export default {
  name: "PendingPayment",
  data() {
    return {};
  },
  mixins: [categoryMixin],
  components: {
    MenuNavigator,
    ProfileTitle
  },
  props: { ordersAllUsers: { type: Boolean, default: false } },
  computed: {
    ...mapGetters({
      user: "cart/getUser",
      isAuthenticated: "cart/isAuthenticated"
    }),
    pendingPaymentInfos() {
      if (this.isAuthenticated) {
        let pendingPaymentInfos = getPersonInfo(this.user.person, 20015);

        if (pendingPaymentInfos && pendingPaymentInfos.length > 0) {
          try {
            let cleanedString = pendingPaymentInfos.trim();
            if (cleanedString.startsWith('"') && cleanedString.endsWith('"')) {
              cleanedString = cleanedString.slice(1, -1);
            }
            cleanedString = cleanedString.replace(/'/g, '"');

            const pendingPaymentInfosJson = JSON.parse(cleanedString);
            if (pendingPaymentInfosJson && pendingPaymentInfosJson.length > 0) {
              return pendingPaymentInfosJson;
            }
          } catch (error) {
            console.error("Error parsing pending payment info:", error);
            return undefined;
          }
        }
      }
      return undefined;
    }
  }
};
</script>
<style lang="scss">
.pending-payment-container {
  .pending-payment-list-item-amount {
    font-size: 18px;
  }
  .pending-payment-text2 {
    font-size: 14px;
  }
}
</style>
